import { ToastController } from 'ionic-angular';
import { Injectable } from '@angular/core';

/*
  Toast message
    info
    error
*/
@Injectable()
export class ToastMessage {

  constructor(public toastCtrl: ToastController) {
    console.log('Hello ToastMessage Provider');
  }

  success(msg:string){
    let toast = this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top',
      // showCloseButton: true, 
      cssClass: 'toastmessage-success'
    });
    console.log("Success: " + msg);
    toast.present();
  }


  message(msg:string){
    let toast = this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top',
      cssClass: 'toastmessage-message'
    });
    console.log("Message: " + msg);
    toast.present();
  }

  error(msg :string, err ?:Error){

    let theMsg = msg;
    if (err) theMsg = theMsg + " : " + err.message;
  
    let toast = this.toastCtrl.create({
      message: theMsg,
      duration: 10000,
      position: 'top',
      showCloseButton: true,
      cssClass: 'toastmessage-error'
    });
    console.log("Error: " + theMsg);
    toast.present();
  }


}



// WEBPACK FOOTER //
// ./src/providers/toast-message.ts